import { CATEGORY } from 'modules/analytics-provider/analytics-provider.constants';


export const INITIAL_SUCCESS_ANALYTICS_DATA = {
    flowStep: 'redeem successful',
    action: 'redeem successful : redeemed',
    category: CATEGORY.DISPLAY
};

export const ON_SUBMIT_ANOTHER_CODE_ANALYTICS_DATA = {
    ...INITIAL_SUCCESS_ANALYTICS_DATA,
    category: CATEGORY.ACTION,
    action: 'redeem successful : submit another code'
};
